import { Price } from "./Domain";
import formatCurrency from "./formatCurrency";

export default (price: Price) => formatCurrency(price?.grossAmount);
